import { render, staticRenderFns } from "./DesignStudioModal.vue?vue&type=template&id=188fe959"
import script from "./DesignStudioModal.vue?vue&type=script&lang=js"
export * from "./DesignStudioModal.vue?vue&type=script&lang=js"
import style0 from "./DesignStudioModal.vue?vue&type=style&index=0&id=188fe959&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports